/* 
	<template>
		// 使用state标签，定义字典名称dict、值value
		<c-state dict="dictName" value="1"></c-state>
		// 使用异步数据定义async属性
		<c-state dict="dictName" async value="1"></c-state>
		
		// 下拉框、单复选框直接使用下面引入的选项数据
		<c-select :options="dictName"></c-select>
		<c-radio-group :options="dictName"></c-radio-group>
		<c-checkbox-group :options="dictName"></c-checkbox-group>
	</template>

	<script>
		// 获取本地选项数据
		// 导入mapState方法
		import {mapState} from 'vuex'
		export default {
			computed: {
				// 获取dictName选项数据
				...mapState(['dictName'])
			}
		}
		
		// 获取异步选项数据
		// 导入asyncMapState方法
		import {asyncMapState} from '@/store'
		export default {
			computed: {
				// 获取dictName选项数据
				...asyncMapState(['dictName'])
			}
		}
	</script>
 */

/* 支持颜色
 * gray 灰色
 * blue 蓝色
 * red 红色
 * green 绿色
 * yellow 黄色
 * orange 橙色
 */

export default {
	// 是/否
	enableDic: [{
		name: '是',
		value: 1,
		color: 'green'
	}, {
		name: '否',
		value: 0,
		color: 'gray'
	}],
	// 启用/停用
	disableEnableDic: [{
		name: '启用',
		value: 1,
		color: 'green'
	}, {
		name: '禁用',
		value: 2,
		color: 'gray'
	}],
	// 普通工厂/行业模版
	saasTypeDic: [{
		name: '工厂',
		value: 2
	},{
		name: '行业方案',
		value: 1,
		color: 'red'
	}],
	// 专业版/免费版
	vipDic: [{
		name: '免费版',
		value: 2
	},{
		name: '专业版',
		value: 1,
		color: 'goldenrod'
	}],
	//销售商品总体状态（对应 SaleProductOverallStateEnum / tbl_sale_product.overall_state，与 PC/H5 端 saleOverallStateDic 同义同值）
	saleOverallStateDic: [{
		name: '待上架',
		value: 1,
		color: 'yellow'
	}, {
		name: '已上架',
		value: 2,
		color: 'green'
	}, {
		name: '已下架',
		value: 3,
		color: 'gray'
	}, {
		name: '锁定中',
		value: 4,
		color: 'red'
	}, {
		name: '已售出',
		value: 5,
		color: 'green'
	}],
	//上架渠道类型（sale_channel_type：1暗拍渠道/2靓机渠道）
	saleChannelTypeDic: [{
		name: '暗拍渠道',
		value: 1,
		color: 'blue'
	}, {
		name: '靓机渠道',
		value: 2,
		color: 'green'
	}],
	//销售状态
	salesStateDic: [{
		name: '待跟进',
		value: 1,
		color: 'yellow'
	},{
		name: '跟进中',
		value: 2,
		color: 'red'
	},{
		name: '已合作',
		value: 3,
		color: 'green'
	},{
		name: '无意向',
		value: 4,
		color: 'gray'
	},{
		name: '渠道',
		value: 5,
		color: 'blue'
	},{
		name: '其他',
		value: 6,
		color: ''
	}],
	dateRangDic: [{
		name: '今日',
		value: 1
	},{
		name: '3天内',
		value: 3
	},{
		name: '7天内',
		value: 7
	},{
		name: '15天内',
		value: 15
	},{
		name: '30天内',
		value: 30
	}],
	registerSourceDic: [{
		name: '电脑端',
		value: 0,
		color: 'brown'
	},{
		name: '移动端',
		value: 1,
		color: 'blue'
	},{
		name: '管理后台',
		value: 2,
		color: 'green'
	}],
	printTypeDic:[{
		name: '浏览器原生打印',
		value: 1,
		color: 'green'
	},{
		name: 'Lodop控件打印',
		value: 2,
		color: 'blue'
	}],
	batchStockDic:[{
		name: '常规库存模式',
		value: 0,
		color: 'green'
	},{
		name: '批次库存模式',
		value: 1,
		color: 'blue'
	}],
	appHomeTypeDic:[{
		name: '单页打开',
		value: 0,
		color: 'green'
	},{
		name: '弹框打开',
		value: 1,
		color: 'blue'
	}],
	attributeTypeOptions:[
		{name: '选项',value: 4, color: 'green'},
		{name: '文本',value: 1, color: 'orange'},
		{name: '数字',value: 2, color: 'brown'},
		{name: '时间',value: 3, color: 'blue'}
		/*{name: '附件',value: 5, color: 'blue'},
		{name: '图片',value: 6, color: 'blue'},
		{name: '其他',value: 7, color: 'blue'},*/
	],
	timeFormatOptions: [{
		name: '年-月-日',
		value: 'yyyy-MM-dd|date'
	}, {
		name: '年-月-日 时',
		value: 'yyyy-MM-dd hh|datetime|hour'
	}, {
		name: '年-月-日 时:分',
		value: 'yyyy-MM-dd hh:mm|datetime|min'
	}, {
		name: '年-月-日 时:分:秒',
		value: 'yyyy-MM-dd hh:mm:ss|datetime|sec'
	}, {
		name: '时:分:秒',
		value: 'hh:mm:ss|time|sec'
	}]
}